export function avatarColor(id) {
  const palette = ['#7c3aed', '#2563eb', '#059669', '#b45309', '#db2777', '#0891b2', '#dc2626', '#65a30d'];
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return palette[Math.abs(hash) % palette.length];
}

export function getOtherProfile(friendRow, userId) {
  return friendRow.requester_id === userId ? friendRow.addressee : friendRow.requester;
}
